import React from "react";
import "./Benefits.css";

const Benefits = () => {
  const benefits = [
    {
      number: "01",
      title: "Taxas Reduzidas",
      description:
        "Condições competitivas e parcelas planejadas para caber no seu orçamento."
    },
    {
      number: "02",
      title: "Liberação Rápida",
      description:
        "Após a aprovação e formalização do contrato, o crédito pode ser liberado em até 48 horas. (contratos novos)"
    },
    {
      number: "03",
      title: "Segurança",
      description:
        "Um processo transparente e seguro, com todas as condições apresentadas antes da contratação."
    },
    {
      number: "04",
      title: "Atendimento Personalizado",
      description:
        "Consultores preparados para entender seu momento e encontrar a solução mais adequada."
    }
  ];

  const testimonials = [
    {
      quote:
        "Fui muito bem atendida durante todo o processo. Tiraram minhas dúvidas, explicaram tudo direitinho e acompanharam minha solicitação até a liberação.",
      name: "Juliana Martins",
      location: "Lages/SC"
    },
    {
      quote:
        "O que mais gostei foi a transparência. Antes de contratar, me explicaram as condições e tiraram todas as minhas dúvidas. Foi muito mais tranquilo do que eu esperava.",
      name: "Carlos Eduardo",
      location: "Cuiabá/MT"
    },
    {
      quote:
        "Procurei a Egel para verificar uma opção de crédito e fui surpreendida pela rapidez no atendimento. O consultor me orientou em cada etapa e facilitou bastante o processo.",
      name: "Ana Paula Ferreira",
      location: "Goiânia/GO"
    }
  ];

  return (
    <section id="vantagens" className="section benefits">
      <div className="container">
        <div className="benefits-list">
          {benefits.map((benefit) => (
            <article className="benefit" key={benefit.number}>
              <span className="benefit-number">{benefit.number}</span>

              <div className="benefit-content">
                <h3>{benefit.title}</h3>

                <p>{benefit.description}</p>
              </div>

              <span className="benefit-line" aria-hidden="true" />
            </article>
          ))}
        </div>

        <div className="testimonials">
          <div className="testimonials-head">
            <div>
              <h2 className="testimonials-title">
                O que diz quem já contratou a Egel
              </h2>
            </div>

            <p className="testimonials-description">
              Histórias de quem encontrou uma solução financeira para o seu
              momento.
            </p>
          </div>

          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <figure className="testimonial" key={testimonial.name}>
                <div className="testimonial-mark" aria-hidden="true">
                  “
                </div>

                <blockquote>{testimonial.quote}</blockquote>

                <figcaption>
                  <strong>{testimonial.name}</strong>
                  <span>{testimonial.location}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;